module.exports = __webpack_public_path__ + "static/media/chemistry.53db19ad.png";